/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  VwbSystemNotification,
} from '../models';
import {
    VwbSystemNotificationFromJSON,
    VwbSystemNotificationToJSON,
} from '../models';

export interface VwbSystemNotificationAdminApiCreateVwbSystemNotificationRequest {
    vwbSystemNotification: VwbSystemNotification;
}

export interface VwbSystemNotificationAdminApiDeleteVwbSystemNotificationRequest {
    id: string;
}

/**
 * 
 */
export class VwbSystemNotificationAdminApi extends runtime.BaseAPI {

    /**
     * Creates a notification in Verily Workbench, shown to all users in the All of Us organization. This is the Verily Workbench equivalent of an All of Us service banner.
     */
    async createVwbSystemNotificationRaw(requestParameters: VwbSystemNotificationAdminApiCreateVwbSystemNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VwbSystemNotification>> {
        if (requestParameters.vwbSystemNotification === null || requestParameters.vwbSystemNotification === undefined) {
            throw new runtime.RequiredError('vwbSystemNotification','Required parameter requestParameters.vwbSystemNotification was null or undefined when calling createVwbSystemNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/system-notification`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VwbSystemNotificationToJSON(requestParameters.vwbSystemNotification),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VwbSystemNotificationFromJSON(jsonValue));
    }

    /**
     * Creates a notification in Verily Workbench, shown to all users in the All of Us organization. This is the Verily Workbench equivalent of an All of Us service banner.
     */
    async createVwbSystemNotification(vwbSystemNotification: VwbSystemNotification, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VwbSystemNotification> {
        const response = await this.createVwbSystemNotificationRaw({ vwbSystemNotification: vwbSystemNotification }, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the specified Verily Workbench system notification, in Verily Workbench and in the Workbench database
     */
    async deleteVwbSystemNotificationRaw(requestParameters: VwbSystemNotificationAdminApiDeleteVwbSystemNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteVwbSystemNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/system-notification/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the specified Verily Workbench system notification, in Verily Workbench and in the Workbench database
     */
    async deleteVwbSystemNotification(id: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteVwbSystemNotificationRaw({ id: id }, initOverrides);
    }

    /**
     * Returns the Verily Workbench system notifications created for the All of Us organization, most recently created first.
     */
    async listVwbSystemNotificationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VwbSystemNotification>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/system-notification`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VwbSystemNotificationFromJSON));
    }

    /**
     * Returns the Verily Workbench system notifications created for the All of Us organization, most recently created first.
     */
    async listVwbSystemNotifications(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VwbSystemNotification>> {
        const response = await this.listVwbSystemNotificationsRaw(initOverrides);
        return await response.value();
    }

}
